import React, { useState } from 'react';
import { FaFire, FaPlay, FaRegStar, FaStar } from 'react-icons/fa';
import './GameCard.scss';

const GameCard = ({ game, gameData, isFavorited, onToggleFavorite, onClick }) => {
  const { title, description } = game;
  const { currentStreak, isCompleted } = gameData;
  const [isPlayHovered, setIsPlayHovered] = useState(false);

  const cardClasses = [
    'game-card',
    isCompleted ? 'game-card--completed' : ''
  ].join(' ').trim();

  const handleStarClick = (e) => {
    e.stopPropagation();
    onToggleFavorite();
  };

  const handlePlayClick = (e) => {
    e.stopPropagation();
    onClick();
  };

  const handlePlayHover = (isHovered) => {
    setIsPlayHovered(isHovered);
  };

  return (
    <div 
      className={cardClasses}
    >
      <div className="game-card__header">
        <div className="game-card__star" onClick={handleStarClick}>
          {isFavorited ? (
            <FaStar className="game-card__star-icon game-card__star-icon--favorited" />
          ) : (
            <FaRegStar className="game-card__star-icon" />
          )}
        </div>
        <div 
          className="game-card__action"
          onMouseEnter={() => handlePlayHover(true)}
          onMouseLeave={() => handlePlayHover(false)}
          onClick={handlePlayClick}
        >
          <FaPlay className="game-card__play-icon" />
        </div>
      </div>

      <div className="game-card__content">
        <h3 className="game-card__title">{title}</h3>
        <p className="game-card__description">{description}</p>
      </div>

      <div className="game-card__stats">
        <div className="game-card__stat">
          <div className="game-card__stat-content">
            <div className="game-card__stat-number">{currentStreak}</div>
            <div className="game-card__stat-label">Streak</div>
          </div>
          <div className="game-card__stat-icon">
            <FaFire />
          </div>
        </div>
      </div>

      <div className={`game-card__overlay ${isPlayHovered ? 'game-card__overlay--visible' : ''}`}>
        <div className="game-card__overlay-content">
          {isCompleted ? 'Completed!' : 'Start Challenge'}
        </div>
      </div>
    </div>
  );
};

export default GameCard;